import React from 'react';
import Icon from '../../../components/AppIcon';

const DelegationsList = ({ delegations, onRevoke }) => {
  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-success/10 text-success border-success',
      expired: 'bg-muted/10 text-muted-foreground border-muted',
      revoked: 'bg-error/10 text-error border-error'
    };
    return colors?.[status] || colors?.active;
  };

  const isExpired = (validUntil) => {
    if (!validUntil) return false;
    return new Date(validUntil) < new Date();
  };

  return (
    <div className="space-y-4">
      {delegations?.map((delegation) => (
        <div key={delegation?.id} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-start justify-between mb-3">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h4 className="text-base font-semibold text-foreground">
                  {delegation?.stepName}
                </h4>
                <span className={`px-2 py-1 rounded text-xs font-medium border ${
                  getStatusColor(isExpired(delegation?.validUntil) ? 'expired' : 'active')
                }`}>
                  {isExpired(delegation?.validUntil) ? 'Expired' : 'Active'}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-3">
                {delegation?.entityType}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-3">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Delegated From</p>
              <p className="text-sm text-foreground font-medium">{delegation?.delegatedFromEmail}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Delegated To</p>
              <p className="text-sm text-foreground font-medium">{delegation?.delegatedToEmail}</p>
            </div>
            {delegation?.validUntil && (
              <div>
                <p className="text-xs text-muted-foreground mb-1">Valid Until</p>
                <p className="text-sm text-foreground font-medium">
                  {new Date(delegation?.validUntil)?.toLocaleString()}
                </p>
              </div>
            )}
            <div>
              <p className="text-xs text-muted-foreground mb-1">Delegated At</p>
              <p className="text-sm text-foreground font-medium">
                {new Date(delegation?.delegatedAt)?.toLocaleString()}
              </p>
            </div>
          </div>
          {delegation?.delegationReason && (
            <div className="bg-muted/5 rounded p-3 mb-3">
              <p className="text-xs text-muted-foreground mb-1">Reason</p>
              <p className="text-sm text-foreground">{delegation?.delegationReason}</p>
            </div>
          )}
          {!isExpired(delegation?.validUntil) && (
            <button
              onClick={() => onRevoke?.(delegation?.id)}
              className="text-sm text-error hover:underline flex items-center gap-1"
            >
              <Icon name="XCircle" size={14} />
              Revoke Delegation
            </button>
          )}
        </div>
      ))}
      {delegations?.length === 0 && (
        <div className="text-center py-8 text-muted-foreground">
          <Icon name="UserPlus" size={32} className="mx-auto mb-2 opacity-50" />
          <p>No active delegations</p>
        </div>
      )}
    </div>
  );
};

export default DelegationsList;